import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { AdSense } from '../components/AdSense';

export function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.message || 'Request failed');
        setLoading(false);
        return;
      }

      setSuccess('If an account exists with this email, you will receive a password reset link shortly.');
      setEmail('');
      
      // Redirect to login after 3 seconds
      setTimeout(() => {
        navigate('/login', { replace: true });
      }, 3000);
    } catch (err) {
      console.error('Error:', err);
      setError('Connection error. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-6 col-sm-8">
            <div className="card shadow border-0 rounded-lg">
              <div className="card-body p-4">
                <h2 className="card-title text-center mb-2 fw-bold">Forgot Password</h2>
                <p className="text-center text-muted mb-4">
                  Enter your email address and we'll send you a link to reset your password.
                </p>

                {error && <div className="alert alert-danger mb-4">{error}</div>}
                {success && <div className="alert alert-success mb-4">{success}</div>}

                {!success ? (
                  <form onSubmit={handleForgotPassword}>
                    <div className="mb-4">
                      <label htmlFor="email" className="form-label">Email Address</label>
                      <input
                        type="email"
                        id="email"
                        className="form-control"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={loading}
                        autoComplete="email"
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary w-100 btn-lg"
                      disabled={loading}
                    >
                      {loading ? 'Sending...' : 'Send Reset Link'}
                    </button>
                  </form>
                ) : null}

                <div className="mt-4 text-center">
                  <p className="text-muted">
                    Remember your password?{' '}
                    <Link to="/login" className="text-decoration-none fw-bold">
                      Back to Login
                    </Link>
                  </p>
                </div>

                <div className="mt-3 text-center">
                  <p className="text-muted">
                    Don't have an account?{' '}
                    <Link to="/signup" className="text-decoration-none fw-bold">
                      Sign up
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AdSense />

        <Footer />
      </div>
    </div>
  );
}
